@if (status$ | async; as status) {
@if (status.loadingAnArticle && status.downloadID === '') {
<div class="loading-screen-parent">
    <div class="fade">

    </div>
    <div class="progress-container">
        <ngb-progressbar [value]="100" [striped]="true" [animated]="true"></ngb-progressbar>
    </div>
</div>
}
<div class="row opacity-100">
    <div class="col">
        @if (status.error) {
        <div class="alert alert-danger" role="alert">
            Error loading content -- please try again
        </div>
        }
    </div>
</div>

}